<template>
  <div id="dashboard" class="fixWidth container-fluid" tag="section">
    <v-row>
      <v-col
        cols="12"
        sm="6"
        lg="4"
        @click="goToinstitute()"
        style="cursor: pointer"
      >
        <base-material-stats-card
          color="info"
          icon="mdi-domain"
          title="Institute"
          :value="JSON.stringify(getfacilityDashboardItem.total_institute)"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="4"
        @click="goToStudent()"
        style="cursor: pointer"
      >
        <base-material-stats-card
          color="orange"
          icon="mdi-account-group"
          title="Student"
          :value="JSON.stringify(getfacilityDashboardItem.total_student)"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="4"
        @click="goToTeacher()"
        style="cursor: pointer"
      >
        <base-material-stats-card
          color="gray"
          icon="mdi-account-group"
          title="Teacher"
          :value="JSON.stringify(getfacilityDashboardItem.total_teacher)"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="4"
        @click="goToJournal()"
        style="cursor: pointer"
      >
        <base-material-stats-card
          color="blue"
          icon="mdi-book-education"
          title="E-book"
          :value="JSON.stringify(getfacilityDashboardItem.total_ebook)"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="4"
        @click="goToJournal()"
        style="cursor: pointer"
      >
        <base-material-stats-card
          color="blue"
          icon="mdi-book"
          title="Journal"
          :value="JSON.stringify(getfacilityDashboardItem.total_journal)"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        lg="4"
        @click="goToJournal()"
        style="cursor: pointer"
      >
        <base-material-stats-card
          color="blue"
          icon="mdi-video"
          title="Total E-content"
          :value="JSON.stringify(getfacilityDashboardItem.total_content)"
        />
      </v-col>
      <v-col cols="12" sm="6" lg="6">
        <base-material-card
          icon="mdi-book-education"
          title="Offered-Ongoing Subject"
           height="300"
          style="overflow-y: scroll"
        >
          <v-simple-table>
            <thead>
              <tr>
                <th class="primary--text">Institute Name</th>
                <th class="primary--text">Total Subject</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="item in getfacilityDashboardItem.running_subject"
                :key="item.name"
              >
                <td>{{ item.institute.institute_name_en }}</td>
                <td class="text-center">{{ item.total }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </base-material-card>
      </v-col>
      <v-col cols="12" sm="6" lg="6">
        <base-material-card
          icon="mdi-clipboard-text"
          title="Latest Notice List"
          height="300"
          style="overflow-y: scroll"
        >
          <ul>
            <li
              v-for="item in getfacilityDashboardItem.Latest_notice"
              :key="item.name"
            >
              <a href="javascript:void(0)" @click="noticeList(item)">{{
                item.title
              }}</a>
            </li>
          </ul>
        </base-material-card>
      </v-col>
      <v-col cols="12" sm="12" lg="12">
        <h3>Academic Calendar</h3>
      </v-col>
      <v-col cols="12" sm="12" lg="12">
        <v-sheet height="64">
          <v-toolbar flat>
            <v-btn
              outlined
              class="mr-4"
              color="grey darken-2"
              @click="setToday"
            >
              Today
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small> mdi-chevron-left </v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small> mdi-chevron-right </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right> mdi-menu-down </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Day</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Month</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 days</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <!-- {{getfacilityDashboardItem}} -->
        <v-sheet height="600">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="getfacilityDashboardItem.academic_calender"
            :event-color="getEventColor"
            :type="type"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange"
          ></v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card color="grey lighten-4" min-width="350px" flat>
              <v-toolbar :color="selectedEvent.color" dark>
                <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <p><b> Description:</b></p>
                <span v-html="selectedEvent.description"></span>
              </v-card-text>
              <v-card-text>
                <p><b> Category: </b></p>
                <span v-html="selectedEvent.category"></span>
              </v-card-text>
              <v-card-text>
                <p><b> Place: </b></p>
                <span v-html="selectedEvent.event_place"></span>
              </v-card-text>
              <v-card-text>
                <p><b> Start Time: </b></p>
                <span v-html="selectedEvent.start"></span>
              </v-card-text>
              <v-card-text>
                <p><b> End Time: </b></p>
                <span v-html="selectedEvent.end"></span>
              </v-card-text>
              <v-card-text>
                <p><b> Notification (In Minutes): </b></p>
                <span v-html="selectedEvent.notification_before"></span>
              </v-card-text>
              <v-card-actions>
                <v-btn text color="secondary" @click="selectedOpen = false">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import { GChart } from "vue-google-charts";
import functionalMixin from "../../mixins/searchFunction";

export default {
  name: "DashboardDashboard",
  components: {
    GChart,
  },
  mixins: [functionalMixin],

  data() {
    return {
      showTab: 1,
      chartOptions: {
        chart: {
          width: this.getSvgWidth,
          height: 600,
          colors: ["green", "blue", "orange"],
          curveType: "function",
        },
      },
      focus: "",
      type: "month",
      typeToLabel: {
        month: "Month",
        week: "Week",
        day: "Day",
        "4day": "4 Days",
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      colors: [
        "blue",
        "indigo",
        "deep-purple",
        "cyan",
        "green",
        "orange",
        "grey darken-1",
      ],
      names: [
        "Meeting",
        "Holiday",
        "PTO",
        "Travel",
        "Event",
        "Birthday",
        "Conference",
        "Party",
      ],

      list: {
        0: false,
        1: false,
        2: false,
      },
    };
  },
  mounted() {
    this.$refs.calendar.checkChange();
    this.$store.dispatch("callfacilityDashboardData");
  },
  methods: {
    noticeList(val) {
      this.$router.push(`/notice-details/${val.id}`);
    },
    goToinstitute() {
      this.$router.push("/admin/institute-new");
    },
    goToStudent() {
      this.$router.push("/admin/student-list");
    },
    goToTeacher() {
      this.$router.push("/admin/teacher-new");
    },
    goToJournal() {
      this.$router.push("/admin/eContent");
    },
    // goToEbook(){
    //     this.$router.push("/");
    // },
    complete(index) {
      this.list[index] = !this.list[index];
    },
    tabView(tab) {
      this.showTab = tab;
    },
    viewDay({ date }) {
     //  console.log("viewDay");
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
     //  console.log("showEvent");
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  },
  computed: {
    getfacilityDashboardItem() {
      return this.$store.getters.getfacilityDashboardItem;
    },
    dailyAttendanceData() {
      let temp = this.$store.getters.getfacilityDashboardItem;
      if (temp.daily_attendance) {
        if (temp.daily_attendance.length > 1) {
          for (let i = 1; i < temp.daily_attendance.length; i++) {
            for (let j = 1; j < temp.daily_attendance[i].length; j++) {
              temp.daily_attendance[i][j] = Number(temp.daily_attendance[i][j]);
            }
          }
        } else {
          temp.daily_attendance.push(["No Data found", 0, 0, 0]);
        }
        return temp.daily_attendance;
      } else {
        return temp;
      }
    },
    weeklyAttendanceData() {
      let temp = this.$store.getters.getfacilityDashboardItem;
      if (temp.weekly_attendance) {
        if (temp.weekly_attendance.length > 1) {
          for (let i = 1; i < temp.weekly_attendance.length; i++) {
            for (let j = 1; j < temp.weekly_attendance[i].length; j++) {
              temp.weekly_attendance[i][j] = temp.weekly_attendance[i][j];
            }
          }
        } else {
          temp.weekly_attendance.push(["No Data found", 0, 0, 0]);
        }
        return temp.weekly_attendance;
      } else {
        return temp;
      }
    },
    getSvgWidth() {
      return window.innerWidth;
    },
  },
  watch: {
    getSvgWidth(val) {
     //  console.log("widthChange");
    },
  },
};
</script>
<style>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined), .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover{
  color: black;
  font-weight: bolder;
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
  margin-right: 0px;
}

</style>
